import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Grid, IconButton, Drawer, Button, List, ListItem, ListItemText, TextField, Tabs, Tab } from '@mui/material';
import {
  Card, CardActionArea, CardMedia, CardContent, Typography, Box, InputAdornment, useMediaQuery
} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Post from './Post';
import { UserContext } from '../contexts/UserContext';
import { Link } from 'react-router-dom';
import { formatISO9075 } from 'date-fns';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BiCommentDetail } from "react-icons/bi";
import SearchIcon from '@mui/icons-material/Search';
import { useDBPosts  } from '../contexts/DBPostsContext'; // Import PostContext
import AuthModal from "../components/AuthModal";
import FavPosts from '../components/FavPosts';
import { FaBell } from "react-icons/fa6";
import SideContent from "../components/SideContent"
const categories = ['All', 'Culinary Tips', 'Restaurant Management', 'Travel & Food', 'Recipes'];

const Blog = () => {
  const { userInfo, setUserInfo, fetchUserProfile, profileLoading } = useContext(UserContext);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const { posts, isLoading, toggleFavoritePost, fetchPosts } = useDBPosts(); // Add fetchPosts to your context
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [filteredArticles, setFilteredArticles] = useState(posts); // State to hold filtered posts
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const [favPosts, setFavPosts] = useState([]);
  
  // Update filteredArticles when posts, category, or search query changes
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  useEffect(() => {

    setLoading(true);
    // Filter posts and exclude `content`
    const filtered = posts
      .filter(post =>
        (selectedCategory === 'All' || post.category === selectedCategory) &&
        (post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          post.summary.toLowerCase().includes(searchQuery.toLowerCase()))
      )
      .map(post => {
        // Destructure post and exclude content
        const { content, ...postWithoutContent } = post;
        return postWithoutContent;
      });
  
    setFilteredArticles(filtered);
    setLoading(false)
  }, [posts, selectedCategory, searchQuery]);
  



  useEffect(() => {
    // Check if userInfo exists and favourites are populated
    if (userInfo && userInfo.favourites && !profileLoading) {
      setFavPosts(userInfo.favourites); // Set favorite posts from userInfo
      console.log(`fav posts for ${userInfo.username} are: ${userInfo.favourites}`)
    }
  }, [userInfo, profileLoading]);



const handleToggleFavorite = async (post) => {
  if (!userInfo) {
    console.log("User not authenticated, showing auth modal.");
    setShowAuthModal(true);
    return;
  }

  try {
    const postId = post._id;
    
    // Update the server and get the updated post data back
    const result = await toggleFavoritePost(postId); // This returns the updated post from the server

    // Check if the operation was successful
    if (result && result.success && result.updatedPost) {
      const updatedPost = result.updatedPost;

        // Refetch the user profile to get updated favorites
        await fetchUserProfile(); // Refetch and update userInfo with updated favourites
        
      // Update the list of filteredArticles with the updated post
      setFilteredArticles(prev =>
        prev.map(p => (p._id === postId ? { ...p, ...updatedPost } : p)) // Merge the old and new post data
      );
            
 

      return result; // Return the result to Post.js for updating UI
    } else {
      throw new Error("Failed to update the post.");
    }
  } catch (error) {
    console.error('Error toggling favorite:', error);
    throw error; // Throw error so that Post.js can handle it
  }
};



  return (
    <Grid 
    container
 
    columnGap={5}        
    sx={{
        display: 'flex',
       
        alignItems: 'start',
        padding: '3% 10%'
    }}
    >
  <Grid container spacing={2}>
  <Grid container item alignItems="center" spacing={2}>
    <Grid item md={10} xs={12}>
      <TextField
        variant="outlined"
        placeholder="Search"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ width: '100%' }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
          sx: {
            borderRadius: '25px', // Rounded corners
            padding: '2px 12px',  // Add padding for a cleaner look
          },
        }}
      />
    </Grid>
    <Grid item md={1}  xs={12} display="flex" justifyContent="end" alignItems="center">
      <IconButton onClick={() => setDrawerOpen(true)} className="post-icon-active" style={{padding: 0, marginRight:'0.5rem'}}>
        <FavoriteIcon fontSize="large" />
      </IconButton>
      <Typography variant="h5" component="h5" align="center" gutterBottom>
          ( {favPosts.length || 0} )
          </Typography>
    </Grid>
    <Grid item md={1}  xs={12} display="flex" justifyContent="end" alignItems="center">
      {/* <IconButton onClick={() => setDrawerOpen(true)} className="post-icon-active" style={{padding: 0, marginRight:'0.5rem'}}>
        <FaBell  fontSize="large" />
      </IconButton>
      <Typography variant="h5" component="h5" align="center" gutterBottom>
          ( {userInfo?.favourites?.length || 0} )
          </Typography> */}
    </Grid>
  </Grid>
</Grid>


<Grid item 
  my={5} 
  md={7}
  
  sx={{
    overflow: 'auto',  // Enable scrolling
    whiteSpace: 'nowrap',  // Prevent wrapping
    display: 'flex',  // Use flexbox
    justifyContent: 'center',  // Center the tabs
    alignItems: 'center'
  }}
>
  <Tabs

    value={selectedCategory}
    onChange={(e, newValue) => setSelectedCategory(newValue)}
    aria-label="categories tabs"
    sx={{
      width:'100%',
      // display: 'flex',  // Use flex for tabs
      // flexWrap: 'nowrap',  // Prevent wrapping
      '.MuiTabs-indicator': {
        backgroundColor: '#ca7735',  // Custom color for the indicator
      },
      // overflow: 'auto',  // Enable scrolling
      // whiteSpace: 'nowrap'  // Prevent wrapping
    }}
    textColor="inherit"  // Use inherit to manage text color through sx on Tab
      variant="scrollable"
        scrollButtons="auto"
  >
    {categories.map(category => (
      <Tab 
        sx={{
          padding: '2% 3%', 
          width: 'fit-content', 
          color: 'black', 
          '&.MuiTab-root.Mui-selected': { color: '#ca7735' }
        }} 
        key={category} 
        value={category} 
        label={category} 
      />
    ))}
  </Tabs>
</Grid>

<Grid container sm={12} md={7} lg={7} display="block">
  {filteredArticles.map(post => {
    // Create a shallow copy of the post object without the `content` field
    const { content, ...postWithoutContent } = post;

    return (
      <Post
        OnContextLoad={isLoading}
        onLoad={loading}
        key={post._id}
        postInfo={postWithoutContent}  // Pass the post data excluding content
        onToggleFavorite={() => handleToggleFavorite(post)} // Pass toggle favorite function
      />
    );
  })}
    <AuthModal showAuthModal={showAuthModal} setShowAuthModal={setShowAuthModal} />
</Grid>

    


      
            {/* Featured Section */}
            <Grid container md={4} lg={4}   
            sx={{marginY:isSmallScreen ? "10rem": ''}} 
            >
          <SideContent/>
            </Grid>
        
{/* Drawer to show favorite posts */}
<Drawer 
  anchor="bottom" 
  open={drawerOpen} 
  onClose={() => setDrawerOpen(false)} 
  sx={{ height: '80vh' }}
>
  <Box 
    sx={{ padding: '2% 6%', height: '100%', display: 'flex', flexDirection: 'column' }}
  >
    {/* Section Heading */}
    <Typography variant="h6" sx={{ mb: 2 }}>
      Favorite Posts
    </Typography>

    {/* Horizontal Scroll for Favorite Posts */}
    <Box 
      sx={{ display: 'flex', overflowX: 'auto', flexGrow: 1 }}
    >
      {favPosts.length > 0 ? (
        favPosts.map(favPost => (
          <FavPosts 
            key={favPost._id}
            postInfo={favPost} // Pass post data to FavPosts component
            onToggleFavorite={() => handleToggleFavorite(favPost)} // Handle toggle favorite logic
          />
        ))
      ) : (
        // Message if there are no favorite posts
        <Box 
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
        >
          <Typography variant="h6">
            You don't have any favorite posts!
          </Typography>
        </Box>
      )}
    </Box>
  </Box>
</Drawer>




    </Grid>
  );
};

export default Blog;
